import { DialogManager } from '@/dialogs_new/DialogManager';
import { searchParamKey } from '@/dialogs-routable/_hooks/launch';

/**
 * Location for /my-leading with the project/event/offer selector open, so a
 * failed auto-create lands the user in the flow that asks for an active site.
 */
export default function myLeadingWithSelector() {
  const searchParams = new URLSearchParams();
  searchParams.set(searchParamKey, JSON.stringify([
    DialogManager.SelectorProjectEventOffer.Config()
  ]));

  return {
    pathname: '/my-leading',
    search: searchParams.toString()
  };
}
